import { TEditedData, TPaymentModel } from 'modules/settings/models';
import API from 'services/api';

export const updateContractCancellationExpenses = ({
  payload,
  cancellationExpensesId,
}: {
  payload: TPaymentModel | TEditedData;
  cancellationExpensesId: number;
}) => API.put(`/api/cancellation-expenses/${cancellationExpensesId}`, payload);
